import { sidebarTypes } from '../types';

export const openSidebar = (name, step) => async (dispatch) => {
    dispatch({ type: sidebarTypes.OPEN, name, step });
};

export const closeSidebar = () => async (dispatch) => {
    dispatch({ type: sidebarTypes.CLOSE });
};

export const toggleSidebar = (name) => async (dispatch) => {
    dispatch({ type: sidebarTypes.TOGGLE, name });
};
